var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat_box white",class:{ 'chat_box--scroll': _vm.scroll, ['d-' + _vm.display]: _vm.display },style:({ borderRadius: _vm.borderRadius }),on:{"scroll":_vm.handleScroll}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }